<template>
  <b-modal id="filter-by-category-modal" hide-footer size="lg" :title="title">
    <div class="d-flex h-100">
      <div
        v-for="{ column, label, items } in filterStore.filterPanels"
        :key="column"
        style="width: 300px"
        class="filter-panel"
      >
        <b-list-group-item class="header-item">
          <div class="d-flex justify-content-between align-items-center w-100">
            {{ label }}
            <div class="d-flex" style="gap: 4px">
              <b-icon
                v-for="button in sortButtons"
                :key="button.sort"
                class="sort-icon"
                :class="{ active: filterStore.getSort(column) === button.sort }"
                :icon="button.icon"
                @click="filterStore.setSort(column, button.sort)"
              />
            </div>
          </div>
        </b-list-group-item>
        <b-list-group-item
          v-if="items.some((i) => !i.state)"
          class="toggle-all-item"
          button
          @click="filterStore.selectAll(column)"
        >
          Select All
        </b-list-group-item>
        <b-list-group-item
          v-else
          class="toggle-all-item"
          button
          @click="filterStore.deselectAll(column)"
        >
          Deselect All
        </b-list-group-item>
        <simplebar class="filter-simplebar">
          <b-list-group-item
            v-for="item in items"
            :key="`filter-bubbles-category-by-${item.value}`"
            button
            :active="item.state"
            @click="filterStore.update(column, item.value, !item.state)"
          >
            <div class="content-container">
              {{ item.value
              }}<font-awesome-icon
                class="d-none"
                :icon="item.state ? 'minus' : 'plus'"
              ></font-awesome-icon>
            </div>
          </b-list-group-item>
        </simplebar>
      </div>
    </div>
  </b-modal>
</template>

<script lang="ts">
import Component from 'vue-class-component'

import FilterByCategoryMixin from '@/mixins/FilterByCategoryMixin'
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'

// eslint-disable-next-line no-use-before-define
@Component<FilterByCategoryModal>({
  components: { simplebar },
  watch: {
    // In v1 of filters, we always show all filters, panels will be added and removed later
    allColumns: {
      handler() {
        this.resetActiveColumns()
      },
      immediate: true,
    },
  },
})
export default class FilterByCategoryModal extends FilterByCategoryMixin {}
</script>

<style lang="scss">
#filter-by-category-modal___BV_modal_backdrop_ {
  display: none;
}
#filter-by-category-modal {
  padding: 0 !important;
  bottom: 0;
  overflow-y: hidden;
  .modal-dialog {
    max-width: fit-content;
    height: 100%;
    padding: 1em;
    margin: 0;
    display: flex;
    flex-direction: column;
    .modal-content {
      height: 100%;
      display: flex;
      .modal-body {
        flex: 1;
        min-height: 0;
        .filter-panel {
          border: 1px solid #ccc;
          height: 100%;
          display: flex;
          flex-direction: column;
          &:not(:last-child) {
            border-right-width: 0;
          }
        }
        .filter-simplebar {
          min-height: 0;
          flex: 1;
        }
        .list-group-item:not(.header-item) {
          border-right-width: 0;
          border-left-width: 0;
          .content-container {
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
          }
          &.active {
            background-color: #e5f2ff;
            color: black;
            border-color: #e5f2ff;
          }
          &:hover {
            svg {
              display: block !important;
              color: #bbb;
            }
          }
        }
        .header-item {
          font-weight: 600;
          border-top-width: 0;
          .sort-icon {
            cursor: pointer;
            width: 24px;
            height: 24px;
            border-radius: 4px;
            &:hover {
              box-shadow: 0 0 2px #777;
              color: #444;
            }
            &.active {
              background: #ddd;
            }
          }
        }
        .toggle-all-item {
          font-weight: 600;
          font-size: 14px;
          text-transform: uppercase;
          border-bottom-width: 0;
        }
        .list-group {
          max-height: calc(100% - 5em);
          overflow-y: scroll;
        }
      }
    }
  }
}
</style>
